import { BaseEntityDto, UserRole } from '@fleet-beat/core';

export interface UserInviteDto extends BaseEntityDto {
  id?: string;
  tenantId?: string;
  role?: UserRole;
  email?: string;
  url?: string;
  inviteByEmail?: boolean;
}
